var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormHelperText, Button, Box, Typography, IconButton, Link, CircularProgress, } from "@mui/material";
import { alpha } from "@mui/material/styles";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { buildFieldValidation } from "../../validators/field-components";
import CommentArea from "../common/CommentArea";
import ConfirmDialog from "../common/ConfirmDialog";
import { useElementConditions } from "../../context/FormLogicContext";
import Header from "../common/Header";
import { getCommentFieldName, getInitialValueForElement, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var FILE_REMOVE_BUTTON_CLASS = "file-remove-button";
var getContextButtonCss = function (hoverColor) { return ({
    color: "text.secondary",
    "&:hover, &:focus-visible": {
        color: hoverColor,
    },
}); };
var fileSize = function (bytes) {
    if (bytes === 0)
        return "0 Bytes";
    var k = 1024;
    var sizes = ["Bytes", "KB", "MB", "GB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
};
var isFileTypeAccepted = function (file, acceptedTypes) {
    if (!acceptedTypes)
        return true;
    var fileName = file.name.toLowerCase();
    var mimeType = (file.type || "").toLowerCase();
    return acceptedTypes
        .split(",")
        .map(function (type) { return type.trim().toLowerCase(); })
        .filter(Boolean)
        .some(function (type) {
        if (type.startsWith("."))
            return fileName.endsWith(type);
        if (type.endsWith("/*"))
            return mimeType.startsWith(type.slice(0, -1));
        return mimeType === type;
    });
};
var isFileImage = function (file) {
    if (!file.content || !file.content.substring)
        return false;
    var imagePrefix = "data:image";
    var subStr = file.content.substring(0, imagePrefix.length).toLowerCase();
    return (subStr === imagePrefix ||
        (!!file.type && file.type.toLowerCase().indexOf("image/") === 0));
};
var handleDownloadFile = function (event) {
    var _a;
    event.stopPropagation();
    var currentTarget = event.currentTarget;
    var link = (_a = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.getElementsByTagName) === null || _a === void 0 ? void 0 : _a.call(currentTarget, "a")[0];
    link === null || link === void 0 ? void 0 : link.click();
};
var FileUploadField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var _b = useState(false), isDragActive = _b[0], setIsDragActive = _b[1];
    var _c = useState(false), isUploading = _c[0], setIsUploading = _c[1];
    var _d = useState(null), pendingRemoval = _d[0], setPendingRemoval = _d[1];
    var isUploadingRef = useRef(false);
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var maxSize = element.maxSize || 0;
    var height = "96px";
    var width = "96px";
    var labelText = element.allowMultiple
        ? "Selecionar Arquivos"
        : "Selecionar Arquivo";
    var _e = useElementConditions(element), isVisible = _e.isVisible, isEnabled = _e.isEnabled, isInteractive = _e.isInteractive, fieldRequired = _e.isRequired;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
        });
    }, [element, fieldRequired, isEnabled]);
    var valueKeys = useMemo(function () {
        return element.showCommentArea
            ? [valueKey, getCommentFieldName(valueKey)]
            : [valueKey];
    }, [valueKey, element.showCommentArea]);
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: valueKeys,
        unregister: unregister,
    });
    var _f = useState(null), fileSizeError = _f[0], setFileSizeError = _f[1];
    var _g = useState(null), fileTypeError = _g[0], setFileTypeError = _g[1];
    var inputRef = useRef(null);
    var hasError = !!errors[valueKey] || !!fileSizeError || !!fileTypeError;
    var getFiles = function (fileArray, currentFieldValue, onChange) { return __awaiter(void 0, void 0, void 0, function () {
        var validFiles, fileNames, invalidTypeNames, maxSizeLabel, fileNamesLabel, fileWord, exceedWord, fileNamesLabel, fileWord, verbWord, mappedNewFiles, _a, newValue;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFileSizeError(null);
                    setFileTypeError(null);
                    validFiles = [];
                    fileNames = [];
                    invalidTypeNames = [];
                    fileArray.forEach(function (file) {
                        if (!isFileTypeAccepted(file, element.acceptedTypes)) {
                            invalidTypeNames.push(file.name);
                            return;
                        }
                        if (maxSize > 0 && file.size > maxSize) {
                            fileNames.push(file.name);
                            return;
                        }
                        validFiles.push(file);
                    });
                    if (fileNames.length > 0) {
                        maxSizeLabel = fileSize(maxSize);
                        fileNamesLabel = fileNames.map(function (name) { return "\"".concat(name, "\""); }).join(", ");
                        fileWord = fileNames.length > 1 ? "Os arquivos" : "O arquivo";
                        exceedWord = fileNames.length > 1 ? "excedem" : "excede";
                        setFileSizeError("".concat(fileWord, " ").concat(fileNamesLabel, " ").concat(exceedWord, " o tamanho m\u00E1ximo permitido de ").concat(maxSizeLabel, "."));
                    }
                    if (invalidTypeNames.length > 0) {
                        fileNamesLabel = invalidTypeNames
                            .map(function (name) { return "\"".concat(name, "\""); })
                            .join(", ");
                        fileWord = invalidTypeNames.length > 1 ? "Os arquivos" : "O arquivo";
                        verbWord = invalidTypeNames.length > 1 ? "não são" : "não é";
                        setFileTypeError("".concat(fileWord, " ").concat(fileNamesLabel, " ").concat(verbWord, " de um tipo permitido."));
                    }
                    setIsUploading(true);
                    isUploadingRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 5, 6]);
                    if (!(validFiles.length === 0)) return [3 /*break*/, 2];
                    _a = [];
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, Promise.all(validFiles.map(function (file) {
                        return new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = function () {
                                return resolve({
                                    name: file.name,
                                    type: file.type || "application/octet-stream",
                                    content: reader.result,
                                });
                            };
                            reader.onerror = function (error) { return reject(error); };
                        });
                    })).catch(function () { return []; })];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    mappedNewFiles = _a;
                    newValue = element.allowMultiple
                        ? __spreadArray(__spreadArray([], currentFieldValue, true), mappedNewFiles, true) : mappedNewFiles.slice(0, 1);
                    isUploadingRef.current = false;
                    onChange(newValue);
                    return [3 /*break*/, 6];
                case 5:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var chooseFile = function () {
        var _a;
        if (isUploading)
            return;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleFileChange = function (event, currentFieldValue, onChange) { return __awaiter(void 0, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    files = event.target.files;
                    if (!files)
                        return [2 /*return*/];
                    return [4 /*yield*/, getFiles(Array.from(files), currentFieldValue, onChange)];
                case 1:
                    _a.sent();
                    event.target.value = "";
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDragOver = function (event) {
        if (!isInteractive || isUploading)
            return;
        event.preventDefault();
        setIsDragActive(true);
    };
    var handleDragLeave = function (event) {
        event.preventDefault();
        setIsDragActive(false);
    };
    var handleDrop = function (event, currentFieldValue, onChange) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    setIsDragActive(false);
                    if (!isInteractive || isUploading)
                        return [2 /*return*/];
                    return [4 /*yield*/, getFiles(Array.from(event.dataTransfer.files), currentFieldValue, onChange)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var confirmDialog = function (message, action) {
        if (element.needConfirmRemoveFile) {
            setPendingRemoval({ message: message, confirm: action });
            return;
        }
        action();
    };
    var handleRemoveFile = function (index, val, currentFieldValue, onChange) {
        confirmDialog("Tem certeza de que deseja remover o arquivo \"".concat(val.name, "\"?"), function () { return onChange(currentFieldValue.filter(function (_, i) { return i !== index; })); });
    };
    var clearFiles = function (onChange) {
        confirmDialog("Tem certeza de que deseja remover todos os arquivos?", function () {
            setFileSizeError(null);
            setFileTypeError(null);
            onChange([]);
        });
    };
    var initialValue = useMemo(function () { return getInitialValueForElement(element); }, [element]);
    var renderFileItem = function (file, index, selectedFiles, onChange) {
        var _a;
        var _b;
        var canPreviewImage = (_b = element.allowImagesPreview) !== null && _b !== void 0 ? _b : isFileImage(file);
        return (_jsxs(Box, __assign({ component: "span", onClick: handleDownloadFile, sx: (_a = {
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    width: width,
                    cursor: "pointer"
                },
                _a["&:hover .".concat(FILE_REMOVE_BUTTON_CLASS)] = { opacity: 1 },
                _a["&:hover a"] = { textDecoration: "underline" },
                _a) }, { children: [_jsxs(Box, __assign({ sx: {
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        flexShrink: 0,
                        width: width,
                        minHeight: height,
                        height: height,
                        bgcolor: canPreviewImage ? "action.hover" : "transparent",
                    } }, { children: [canPreviewImage ? (_jsx(Box, { component: "img", src: file.content, alt: "Pr\u00E9-visualiza\u00E7\u00E3o do arquivo", sx: {
                                display: "block",
                                width: width,
                                height: height,
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            } })) : (_jsx(Box, __assign({ sx: { color: "text.secondary", display: "inline-flex" } }, { children: _jsx(InsertDriveFileOutlinedIcon, { sx: { fontSize: 72 } }) }))), file.name && isInteractive ? (_jsx(IconButton, __assign({ size: "small", className: FILE_REMOVE_BUTTON_CLASS, title: element.removeFileCaption || "Remover arquivo", onClick: function (event) {
                                event.stopPropagation();
                                handleRemoveFile(index, file, selectedFiles, onChange);
                            }, sx: __assign(__assign({ position: "absolute" }, (canPreviewImage
                                ? { top: 0, left: "100%", transform: "translate(-50%, -50%)" }
                                : { top: -0.5, right: 5.5, transform: "none" })), { padding: "7px", opacity: 0, transition: "opacity 150ms, color 150ms", color: "error.main", bgcolor: "background.paper", border: "1px solid", borderColor: "divider", "&:hover, &:focus-visible": {
                                    color: "error.main",
                                    background: function (theme) {
                                        var redLight = theme.palette.error.light;
                                        var surface = theme.palette.background.paper;
                                        return "linear-gradient(".concat(redLight, ", ").concat(redLight, "), linear-gradient(").concat(surface, ", ").concat(surface, ")");
                                    },
                                    borderColor: "error.main",
                                }, "&:focus-visible": { opacity: 1 } }) }, { children: _jsx(CloseIcon, { sx: { fontSize: 16 } }) }))) : null] })), file.name && (_jsx(Box, __assign({ sx: { mt: 1, textAlign: "center" } }, { children: _jsx(Link, __assign({ href: file.content, onClick: function (event) { return event.stopPropagation(); }, title: file.name, download: file.name, target: "_blank", rel: "noreferrer", sx: {
                            display: "block",
                            width: width,
                            minWidth: "100%",
                            maxWidth: "100%",
                            maxHeight: "3rem",
                            overflow: "hidden",
                            whiteSpace: "normal",
                            wordBreak: "break-all",
                            fontSize: "0.75rem",
                            lineHeight: "1rem",
                            color: "text.primary",
                            textDecoration: "none",
                        } }, { children: file.name })) })))] }), "".concat(file.name, "-").concat(index)));
    };
    if (!isVisible)
        return null;
    return (_jsxs(Box, __assign({ className: "component-wrapper" }, { children: [_jsxs(FormControl, __assign({ fullWidth: true, error: !!errors[element.name], sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!errors[element.name], isRequired: fieldRequired }), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                if (isUploadingRef.current && element.waitForUpload) {
                                    return "Seu arquivo está sendo carregado. Por favor, aguarde alguns segundos e tente novamente.";
                                }
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var _b;
                            var field = _a.field;
                            var selectedFiles = field.value || [];
                            var isAnswered = selectedFiles.length > 0;
                            return (_jsxs(Box, { children: [_jsx("input", { ref: inputRef, type: "file", multiple: element.allowMultiple, accept: element.acceptedTypes ? element.acceptedTypes : undefined, onChange: function (e) {
                                            return handleFileChange(e, selectedFiles, field.onChange);
                                        }, style: { display: "none" }, disabled: !isInteractive || isUploading }), _jsx(Box, __assign({ onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: function (event) {
                                            return handleDrop(event, selectedFiles, field.onChange);
                                        }, sx: {
                                            position: "relative",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 0.5,
                                            px: 6,
                                            py: 3,
                                            minHeight: 288,
                                            boxSizing: "border-box",
                                            border: isDragActive ? "1px solid" : "1px dashed",
                                            borderColor: isDragActive
                                                ? "primary.main"
                                                : hasError
                                                    ? "error.main"
                                                    : "divider",
                                            bgcolor: function (theme) {
                                                return isDragActive
                                                    ? alpha(theme.palette.primary.main, 0.08)
                                                    : hasError
                                                        ? alpha(theme.palette.error.main, 0.08)
                                                        : "transparent";
                                            },
                                            opacity: isInteractive ? 1 : 0.6,
                                            transition: "background-color 0.2s ease, border-color 0.2s ease",
                                        } }, { children: isUploading ? (_jsx(Box, __assign({ sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: 1.5,
                                            } }, { children: _jsx(CircularProgress, { size: 32 }) }))) : (_jsxs(_Fragment, { children: [!isAnswered && (_jsx(Typography, __assign({ color: "text.secondary", align: "center", sx: { px: 8, whiteSpace: "normal" } }, { children: isInteractive
                                                        ? element.filePlaceholder ||
                                                            "Arraste e solte um arquivo aqui ou selecione um arquivo para carregar"
                                                        : "Nenhum arquivo selecionado" }))), isInteractive && (_jsx(Box, __assign({ sx: __assign({ display: "flex", alignItems: "center", gap: 1 }, (isAnswered
                                                        ? {
                                                            position: "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            zIndex: 2,
                                                        }
                                                        : { justifyContent: "center" })) }, { children: isAnswered ? (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ size: "small", title: labelText, onClick: chooseFile, sx: getContextButtonCss("primary.main") }, { children: _jsx(FolderOutlinedIcon, {}) })), _jsx(IconButton, __assign({ size: "small", title: "Limpar", onClick: function () { return clearFiles(field.onChange); }, sx: getContextButtonCss("error.main") }, { children: _jsx(ClearIcon, {}) }))] })) : (_jsx(Button, __assign({ variant: "text", startIcon: _jsx(FolderOutlinedIcon, {}), onClick: chooseFile, sx: {
                                                            textTransform: "none",
                                                            fontWeight: 600,
                                                            fontSize: "1rem",
                                                        } }, { children: labelText }))) }))), isAnswered && (_jsx(Box, __assign({ sx: {
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        alignItems: "flex-start",
                                                        justifyContent: "center",
                                                        gap: 4,
                                                        mt: 1,
                                                    } }, { children: selectedFiles.map(function (file, index) {
                                                        return renderFileItem(file, index, selectedFiles, field.onChange);
                                                    }) })))] })) })), errors[element.name] && (_jsx(FormHelperText, __assign({ error: true }, { children: (_b = errors[element.name]) === null || _b === void 0 ? void 0 : _b.message }))), fileSizeError && (_jsx(FormHelperText, __assign({ error: true, sx: { mt: errors[element.name] ? 0.5 : 0 } }, { children: fileSizeError }))), fileTypeError && (_jsx(FormHelperText, __assign({ error: true, sx: {
                                            mt: errors[element.name] || fileSizeError ? 0.5 : 0,
                                        } }, { children: fileTypeError }))), element.showCommentArea && (_jsx(CommentArea, { element: element, disabled: !isInteractive }))] }));
                        } })] })), _jsx(ConfirmDialog, { open: !!pendingRemoval, title: "Remover arquivo", message: pendingRemoval === null || pendingRemoval === void 0 ? void 0 : pendingRemoval.message, confirmLabel: "Remover", confirmColor: "error", onCancel: function () { return setPendingRemoval(null); }, onConfirm: function () {
                    pendingRemoval === null || pendingRemoval === void 0 ? void 0 : pendingRemoval.confirm();
                    setPendingRemoval(null);
                } })] })));
};
export default FileUploadField;
